import { T, FEATURE_PLAN } from "../../config/theme.js";
import { Btn } from "../ui/index.jsx";

export default function UpgradeModal({ feature, onClose, goPricing }) {
  const info = FEATURE_PLAN[feature] || { icon: "⚡", title: "고급 기능", desc: "이 기능은 상위 플랜에서 사용할 수 있어요.", plan: "starter" };
  const planLabel = { free: "Free", starter: "Starter", core: "Core", pro: "Pro" };

  // Sprint 23: Pro 플랜은 현재 숨김 상태 → Core로 대체 안내
  const displayPlan = info.plan === "pro" ? "core" : info.plan;
  const displayLabel = planLabel[displayPlan] || "Starter";

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: T.card, borderRadius: 20, border: `1px solid ${T.border}`, maxWidth: 380, width: "100%", padding: "36px 28px", textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>{info.icon}</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: T.text, marginBottom: 8 }}>{info.title}</div>
        <div style={{ fontSize: 13, color: T.textDim, marginBottom: 20, lineHeight: 1.6 }}>{info.desc}</div>
        <div style={{ fontSize: 12, color: T.accent, fontWeight: 700, marginBottom: 20, padding: "8px 16px", background: T.accent + "10", borderRadius: 8 }}>
          {displayLabel} 플랜 이상 필요
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <Btn variant="primary" onClick={goPricing}>플랜 보기</Btn>
          <Btn variant="ghost" onClick={onClose}>닫기</Btn>
        </div>
      </div>
    </div>
  );
}
